const initialStateFilters = {
  ciclo: {id: 1, name: 'Janeiro'},
  compararCiclos: {id: 'ativar', name: 'Ativar'},
  dataInicial: '',
  dataFinal: ''
}
const initialStatePaginate = { 
  pageNumber: 1, 
  totalPages: 1, 
  totalElements: 0,
  perPage: 7
}

const initialState = {
  totalAvaliacao: 0,
  projetos: [],
  infoGrupo: [],
  paginate: initialStatePaginate,
  projeto: {},
  filtersProvisorio: initialStateFilters,
  loadList: false,
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LIST_PROJETOS':
      return { ...state, projetos: payload}
    case 'INFO_GRUPO_TOTAL_AVALIACAO':
      return { ...state, totalAvaliacao: payload}
    case 'LIST_INFO_GRUPO':
      return { ...state, infoGrupo: payload}
    case 'PAGINATE_INFO_GRUPO':
      return { ...state, paginate: {...initialState.paginate, ...payload}}
    case 'INFO_PROJETO':
      return { ...state, projeto: payload}
    case 'INFO_FILTERS_INFO_GRUPO':
      return { ...state, filtersProvisorio: payload}
    case 'CHANGE_FILTERS_INFO_GRUPO':
      return { ...state, filtersProvisorio: {...state.filtersProvisorio, [payload.name]: payload.value}}
    case 'CLEAN_FILTERS_INFO_GRUPO':
      return { ...state, filtersProvisorio: initialStateFilters}
    case 'LOAD_LIST_INFO_GRUPO':
      return { ...state, loadList: payload}

    default:
      return state
  }
}